import React from 'react';
import styles from './AboutMe.module.css';
const dp = process.env.PUBLIC_URL + '/images/dp.JPG';

const AboutMe = () => {
  const expertise = [
    {
      category: "Technical Skills",
      items: [
        "Network Security & Penetration Testing",
        "Web Application Security",
        "Cloud Security (AWS, Azure, GCP)",
        "Security Information and Event Management (SIEM)",
        "Intrusion Detection/Prevention Systems"
      ]
    },
    {
      category: "Pending Certifications",
      items: [
        "Certified Information Systems Security Professional (CISSP)",
        "Certified Ethical Hacker (CEH)",
        "CompTIA Security+",
        "AWS Certified Security Specialist",
        "GIAC Security Essentials (GSEC)"
      ]
    },
    {
      category: "Research Areas",
      items: [
        "Zero-day Vulnerability Research",
        "Advanced Persistent Threats (APTs)",
        "Machine Learning in Cybersecurity",
        "IoT Security",
        "Blockchain Security"
      ]
    }
  ];

  return (
    <div className={styles.container} id="about">
      <div className={styles.profile}>
        <img src={dp} alt="Emmanuel's Profile" className={styles.profilePic} />
        <h1 className={styles.title}>About Me</h1>
        <p className={styles.introduction}>
          As a Cybersecurity Systems Engineer and Researcher, I specialize in developing and implementing
          robust security solutions for organizations. With extensive experience in penetration testing,
          security architecture, and threat analysis, I help businesses protect their digital assets
          against evolving cyber threats.
        </p>
      </div>

      <div className={styles.background}>
        <h2>Professional Background</h2>
        <p>
          My journey in cybersecurity began with a master's thesis focused on developing innovative
          security solutions using Raspberry Pi devices. This led to the creation of several successful
          security projects and contributions to the cybersecurity community through research papers
          and conference presentations.
        </p>
      </div>

      <div className={styles.expertiseSection}>
        <h2>Areas of Expertise</h2>
        <div className={styles.expertiseGrid}>
          {expertise.map((section, index) => (
            <div key={index} className={styles.expertiseCard}>
              <h3>{section.category}</h3>
              <ul>
                {section.items.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.mission}>
        <h2>My Mission</h2>
        <p>
          I am dedicated to making the digital world safer through innovative cybersecurity solutions
          and knowledge sharing. My goal is to help organizations build robust security postures while
          contributing to the advancement of cybersecurity practices globally.
        </p>
      </div>
    </div>
  );
};

export default AboutMe;
